{/*import React, { useState } from "react";

export default function ResumeSection({ value, onUpload, onRemove }) {
  const [preview, setPreview] = useState(value ? value.name : null);

  const handleFile = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setPreview(f.name);
    onUpload(f);
  };

  return (
    <section className="card">
      <div className="card-head">
        <h3>Resume</h3>
        <div className="card-actions">
          {value && <button className="link" onClick={onRemove}>Remove</button>}
        </div>
      </div>

      <div className="card-body">
        <p>Your resume is the first impression you make on potential employers. Upload to auto-parse.</p>
        <div className="upload-box">
          <input id="resume-file" type="file" accept=".pdf,.doc,.docx" onChange={handleFile} />
          <label htmlFor="resume-file" className="upload-btn">Upload resume</label>
          <small>Supported: pdf, docx (parsing simulated)</small>
        </div>
        {preview && <div className="muted">Uploaded: <strong>{preview}</strong></div>}
      </div>
    </section>
  );
}
*/}

// added on 3-12-2025

import React, { useEffect, useState } from "react";

export default function ResumeSection({ value, onUpload, onRemove }) {
  const [preview, setPreview] = useState(null);

  // 🔥 Load backend resume on component mount or when value updates
  useEffect(() => {
    if (value && value.url) {
      // Extract only the filename for display
      const fileName = value.url.split("/").pop();
      setPreview(fileName);
    } else {
      setPreview(null);
    }
  }, [value]);

  const handleFile = (e) => {
    const f = e.target.files[0];
    if (!f) return;

    setPreview(f.name);  // Show uploaded filename immediately
    onUpload(f);         // Upload file to backend
  };

  return (
    <section className="ccard">
      <div className="card-head">
        <h3>Resume</h3>
        <div className="card-actions">
          {value && <button className="link" onClick={onRemove}>Remove</button>}
        </div>
      </div>

      <div className="card-body">
        <p>Your resume is the first impression you make on potential employers. Upload Your Resume</p>

        <div className="upload-box">
          <input id="resume-file" type="file" accept=".pdf,.doc,.docx" onChange={handleFile} />
          <label htmlFor="resume-file" className="upload-btn">Upload resume</label>
          <small>Supported: pdf, docx</small>
        </div>

        {preview && (
          <div className="muted">
            Uploaded: <strong>{preview}</strong>
            {value?.url && (
              <a href={value.url} 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 style={{ marginLeft: "10px", color: "#007bff" }}>
                View
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
}